import * as service from './ManagePersonnelCertifications.Services'
export default {
  data() {
    var context = this
    return {
      pickerOptions: {
        disabledDate(date) {

          if (context.$moment(date).isAfter(new Date())) {
            return true
          }
        }

      },


      Certificationcolumns1: ['CertificationName', 'CertNumber', 'IssuedBy', 'CertificationExpiry', 'AttachedFiles', 'Actions'],
      labelposition: 'right',
      attachmentcolor: 'gray',

      optionstable: {

        headings: {
          Attachments: 'Attachments',
          IssuedBy: 'Issued By',
          CertNumber: 'Number',
          CertificationExpiry: 'Expiration Date',
          CertificationName: 'Certificate Name',
          AttachedFiles: 'Attached Files',
          Actions: ''

        },
        dateColumns: ['CertificationExpiry'],

        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['CertificationDate', 'CertificationExpiry', 'CertificationName'],
        orderBy: {
          column: 'CertificationExpiry',
          ascending: true
        },
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',

        }

      },
      Certifications: [],
      CertificationTypes: [],
      isselfeditable: false,

      otherCertificate: true,
      Attachments: [],
      sampleatt: [],
      certiBackup: [],
      modalTitle: '',
      personnelID: '',
      role: '',
      // image_arr:[],
      AddCertificateForm: {
        Id: '',
        CertificationName: '',
        CertificationDate: '',
        CertificationExpiry: '',
        OtherName: '',
        AttachedFiles: [],
        Instructor: '',
        CertNumber: ''

      },
      image_data: [],
      test_att: [],
      IsCertificateTypeEdit: '',
      attachedfiles: [],
      certificateList: [],
      baseUrl: ''
    }
  },
  mounted() {
    let context = this

    this.personnelID = this.$route.params.id

    if (this.personnelID) {

      this.GetPersonnelCertifications(this.personnelID)
    }

    this.certiBackup = deepcopy(this.AddCertificateForm)

    this.role = JSON.parse(localStorage.getItem('authentication')).role

    let pid = this.$route.params.id ? this.$route.params.id : ''
    if (JSON.parse(localStorage.getItem('authentication')).PersonnelId == pid) {
      this.isselfeditable = true
    } else {
      this.isselfeditable = false
    }

    if (this.role == 'AquaticsDirector' || this.role == 'PoolManager' || this.role == 'AsstPoolManager' || this.role == 'ToolAdmin' || this.isselfeditable) {

      this.GetCertificationTypes()
      this.Certificationcolumns = ['CertificationName', 'CertificationDate', 'CertificationExpiry', 'AttachedFiles', 'Actions']
    } else {
      this.Certificationcolumns = ['CertificationName', 'CertificationDate', 'CertificationExpiry']
    }

  },
  props: ['data', 'editShow'],
  methods: {

    downloadList(cert) {
      this.certificateList = cert.AttachedFiles
      let context = this
      this.certificateList.map(function (el) {
        context.baseUrl = baseUrl + 'Documents/CertificationDocuments/' + el['DocumentPath']

      })

      $('#certificateModel').modal('show')

    },

    showcertificate() {
      this.IsCertificateTypeEdit = false
      let context = this
      this.image_data = []
      this.image_data = new FormData()
      this.modalTitle = 'Add Certificate'
      $('#AddCertificatemodel').modal('show')
      context.Attachments = []

      setTimeout(function () {

        context.$refs['AddCertificateForm'].resetFields()
      }, 10)
      this.AddCertificateForm = deepcopy(this.certiBackup)
    },
    backProfile() {
      this.$router.push('/addpersonnel')

    },

    cEdit() {

      if (this.data['isEdit'] == true) {
        this.data['isEdit'] = false
      } else if (this.data['isEdit'] == false) {
        this.data['isEdit'] = true
      }

    },

    GetCertificationTypes() {
      let context = this
      loader.startLoader()
      service.GetCertificationTypes().then(function (response) {

        context.CertificationTypes = response
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    del: function (data) {

      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeletePersonnelCertification(ID).then(function (response) {

          if (context.personnelID) {
            context.GetPersonnelCertifications(context.personnelID)
          }
          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {
        /*  context.$message({
            type: 'info',
            message: 'Delete canceled'
          })*/
      })

    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false

      $('#AddCertificatemodel').modal('hide')

    },

    EditCertificateType: function (data) {
      let context = this

      loader.startLoader()

      var image_arr = {}

      image_arr['PersonnelId'] = context.personnelID
      image_arr['Id'] = context.AddCertificateForm.Id

      if (this.AddCertificateForm.AttachedFiles.length > 0) {

        for (let i = 0; i < this.AddCertificateForm.AttachedFiles.length; i++) {
          this.attachedfiles.push(this.AddCertificateForm.AttachedFiles[i].DocumentPath)
        }

      }

      image_arr['ChangedAttachFiles'] = context.attachedfiles.toString()
      if (context.AddCertificateForm.OtherName && context.AddCertificateForm.OtherName != "[object Object]") {
        image_arr['CertificationName'] = context.AddCertificateForm.OtherName
      } else {
        image_arr['CertificationName'] = context.AddCertificateForm.CertificationName.Name
      }

      if (context.AddCertificateForm.CertNumber) {
        image_arr['CertNumber'] = context.AddCertificateForm.CertNumber
      } else {
        image_arr['CertNumber'] = ''
      }

      if (context.AddCertificateForm.Instructor) {
        image_arr['Instructor'] = context.AddCertificateForm.Instructor
      } else {
        image_arr['Instructor'] = ''
      }

      if (context.AddCertificateForm.CertificationDate) {
        image_arr['CertificationDate'] = this.$moment(context.AddCertificateForm.CertificationDate).format('MM-DD-YYYY')
      } else {
        image_arr['CertificationDate'] = ''
      }

      if (context.AddCertificateForm.CertificationExpiry) {

        image_arr['CertificationExpiry'] = this.$moment(context.AddCertificateForm.CertificationExpiry).format('MM-DD-YYYY')
      } else {
        image_arr['CertificationExpiry'] = ''
      }

      for (var key in image_arr) {

        this.image_data.append(key, image_arr[key])
      }


      service.UpdateCertificationType(this.image_data).then(function (response) {
        context.IsCertificateTypeEdit = false
        $('#AddCertificatemodel').modal('hide')
        context.CertificateTypeEditID = 0

        context.$notify({
          title: 'Success',
          message: 'Updation Successfull',
          type: 'success'
        })
        if (context.personnelID) {
          context.GetPersonnelCertifications(context.personnelID)
        }
        /*  for (var i = 0; i < context.CertificationTypes.length; i++) {
         if (context.CertificationTypes[i].Id == ID) {h

         context.CertificationTypes[i].Name = data.Name

         context.CertificationTypes[i].Description = data.Description
         break
         }
         }*/

        loader.stopLoader()

      }, (error) => {

        var alr;
        var err = error.responseText
        if (err.match(/Certification already expired/g)) {
          alr = "Certification already expired"
        }

        if (err.match(/Certification already exists/g)) {
          alr = "Certification already exists"
        }

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: alr,

          type: 'error'

        })
      })

    },

    editcol: function (data) {
      $('#AddCertificatemodel').modal('show')
      this.AddCertificateForm = deepcopy(data.row)


      this.Attachments = []
      this.attachedfiles = []
      this.image_data = []
      this.image_data = new FormData()


      var isOther = false
      for (var i = 0; i < this.CertificationTypes.length; i++) {

        if (this.CertificationTypes[i].Name == data.row.CertificationName && this.CertificationTypes[i].Name != 'Other') {
          isOther = true
          break
        }

      }

      if (!isOther) {
        this.otherCertificate = false
        this.AddCertificateForm.CertificationName = 'Other'
        this.AddCertificateForm.OtherName = data.row.CertificationName
      }
      if (this.AddCertificateForm.CertificationExpiry) {


        ;
        var t = this.$moment(this.AddCertificateForm.CertificationExpiry, 'MM-DD-YYYY')

        this.AddCertificateForm.CertificationExpiry = t

      }

      if (this.AddCertificateForm.CertificationDate) {

        var y = this.$moment(this.AddCertificateForm.CertificationDate, 'MM-DD-YYYY')

        this.AddCertificateForm.CertificationDate = y
      } else {

        var y = this.$moment(this.AddCertificateForm.CertificationDate, 'MM-DD-YYYY')

        this.AddCertificateForm.CertificationExpiry = y
      }

      let context = this
      this.CertificationTypes.map(function (item) {
        if (item.Name == context.AddCertificateForm.CertificationName) {
          context.AddCertificateForm.CertificationName = item
        }

      })


      this.IsCertificateTypeEdit = true
      this.modalTitle = 'Edit Certificate'


    },
    changeissue() {
      let context = this


      if (this.AddCertificateForm.CertificationExpiry && context.AddCertificateForm.CertificationName.ExpiryPeriod) {
        if (this.AddCertificateForm.CertificationExpiry != this.AddCertificateForm.CertificationDate) {
          var p = new Date(context.AddCertificateForm.CertificationDate)

          context.AddCertificateForm.CertificationExpiry = context.$moment(p).add(context.AddCertificateForm.CertificationName.ExpiryPeriod, 'days')


        }
      }


    },
    changecertitype() {

      if (this.AddCertificateForm.CertificationName.Name == 'Other') {
        this.otherCertificate = false
      } else {
        this.otherCertificate = true

      }

      if (this.AddCertificateForm.CertificationName.ExpiryPeriod) {
        this.AddCertificateForm.CertificationDate = this.$moment()
        var edate = this.$moment().add(this.AddCertificateForm.CertificationName.ExpiryPeriod, 'days')

        this.AddCertificateForm.CertificationExpiry = edate
      }

    },

    removeattachedtag(tag) {

      let context = this
      let ps = []
      for (var i = 0; i < this.Attachments.length; i++) {

        if (this.Attachments[i].id == tag.id) {

          this.image_data.delete('Attachments[' + i + ']')

          for (var j = 0; j < this.Attachments.length; j++) {
            var files = this.image_data.getAll('Attachments[' + j + ']')
            if (files.length > 0) {

              $.each(files, function (h, v) {
                ps.push(v)
              })
            }

          }

          this.Attachments.splice(i, 1)
          break
        }

      }

      if (ps.length > 0) {
        this.image_data = []
        this.image_data = new FormData()

        for (var k = 0; k < ps.length; k++) {
          this.image_data.append('Attachments[' + k + ']', ps[k])
        }
      }

    },
    removeeditattachmnets(tag) {

      for (var i = 0; i < this.AddCertificateForm.AttachedFiles.length; i++) {

        if (this.AddCertificateForm.AttachedFiles[i].DocumentPath == tag.DocumentPath) {

          this.AddCertificateForm.AttachedFiles.splice(i, 1)
          // this.attachedfiles.push(tag.DocumentPath)

          //this.image_data.append('AttachedFiles[' + i + ']', rf)
          break
        }
      }

    },

    GetPersonnelCertifications(perosonnelID) {
      let context = this
      loader.startLoader()
      service.GetPersonnelCertifications(perosonnelID).then(function (response) {

        context.Certifications = response ? response : []
        if (response) {
          for (var i = 0; i < response.length; i++) {

            if (context.Certifications[i].CertificationDate) {
              context.Certifications[i].CertificationDate = context.$options.filters.fdate(context.Certifications[i].CertificationDate)
            }
            if (context.Certifications[i].CertificationExpiry) {
              context.Certifications[i].CertificationExpiry = new Date(context.Certifications[i].CertificationExpiry)
            } else {
              context.Certifications[i].CertificationExpiry = ''
            }
          }

          tooltip.startTooltip(50)

        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    setAttachment(e) {

      let context = this

      function getExtension(filename) {
        var parts = filename.split('.')
        return parts[parts.length - 1]
      }

      for (var i = 0; i < e.target.files.length; i++) {

        var name = e.target.files[i].name
        var type = e.target.files[i].type
        var size = e.target.files[i].size

        if (type != 'image/jpeg' && type != 'image/jpg' && type != 'image/png' && getExtension(name) != 'docx' && getExtension(name) != 'doc' && getExtension(name) != 'txt' && getExtension(name) != 'pdf') {
          alert('Invalid file format')
          return
        }
        if (size > 5000000) {
          alert('You have exceeded the maximum image size of 5 MB')
          return
        }

        var id = i

        this.image_data.append('Attachments[' + i + ']', e.target.files[i])

        //this.test_att.push(e.target.files[i])
        //this.image_data.append("Attachments", e.target.files[i]);

        // if (!file.type.includes('image/jpeg') && !file.type.includes('image/jpg') && !file.type.includes('image/png')) {
        //   alert('Please select an image file')
        //   return
        // }
        // if (file.size > 200000) {
        //   alert('You have exceeded the maximum image size of 200 Kb')
        //   return
        // }

        this.Attachments.push({
          FileName: name,
          MediaType: type,
          id: id,

        })

      }

    },

    submitForm(formName) {

      let context = this

      this.$refs[formName].validate((valid) => {

        if (valid) {

          let context = this
          loader.startLoader()

          var image_arr = {}

          image_arr['PersonnelId'] = context.personnelID
          if (context.AddCertificateForm.OtherName) {
            image_arr['CertificationName'] = context.AddCertificateForm.OtherName
          } else {
            image_arr['CertificationName'] = context.AddCertificateForm.CertificationName.Name
          }

          if (context.AddCertificateForm.CertNumber) {
            image_arr['CertNumber'] = context.AddCertificateForm.CertNumber
          } else {
            image_arr['CertNumber'] = ''
          }

          if (context.AddCertificateForm.Instructor) {
            image_arr['Instructor'] = context.AddCertificateForm.Instructor
          } else {
            image_arr['Instructor'] = ''
          }




          if (context.AddCertificateForm.CertificationDate) {
            image_arr['CertificationDate'] = this.$moment(context.AddCertificateForm.CertificationDate).format('MM-DD-YYYY')
          } else {
            image_arr['CertificationDate'] = ''
          }

          if (context.AddCertificateForm.CertificationExpiry) {
            image_arr['CertificationExpiry'] = this.$moment(context.AddCertificateForm.CertificationExpiry).format('MM-DD-YYYY')
          } else {
            image_arr['CertificationExpiry'] = ''
          }


          for (var key in image_arr) {

            this.image_data.append(key, image_arr[key])
          }

          service.AddPersonnelCertification(this.image_data).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Succesfully added Certificate',
              type: 'success'
            })
            $('#AddCertificatemodel').modal('hide')
            if (context.personnelID) {
              context.GetPersonnelCertifications(context.personnelID)
            }

            //   alert(response)

          }, (error) => {
            context.image_data = new FormData()
            context.$notify({

              title: 'Error',

              message: error,

              type: 'error'

            })
            loader.stopLoader()


            var alr;
            var err = error.responseText
            if (err.match(/Certification already expired/g)) {
              alr = "Certification already expired"
            }

            if (err.match(/Certification already exists/g)) {
              alr = "Certification already exists"
            }


            this.$notify({

              title: 'Error',

              message: alr,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'PERSONNEL - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

  },

}



// WEBPACK FOOTER //
// ./src/components/ManagePersonnelCertifications/ManagePersonnelCertifications.Controller.js